import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableNoResult } from '@components/Table/TableNoResult';
import { DataRow, IData } from '@hooks/useData';
import { IconButton, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useThemeColor } from '@themes/Colors';
import React from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { IFile, EnumFileUploadStatus } from '@hooks/useFileUpload';

export type ArquivoModalTableProps = {
    data: IData<IFile>
    isLoading: boolean
}

export function ArquivoModalTable ({ data, isLoading }: ArquivoModalTableProps) {
    const themeColor = useThemeColor();

    const statusColors = React.useMemo(() => ({
        [EnumFileUploadStatus.Awaitting]: themeColor.status.laranja,
        [EnumFileUploadStatus.Uploading]: themeColor.status.azul,
        [EnumFileUploadStatus.Success]: themeColor.status.verde,
        [EnumFileUploadStatus.Error]: themeColor.status.vermelho,
    }), [themeColor.status.azul, themeColor.status.laranja, themeColor.status.verde, themeColor.status.vermelho])

    const statusLabels = React.useMemo(() => ({
        [EnumFileUploadStatus.Awaitting]: "Aguardando...",
        [EnumFileUploadStatus.Uploading]: "Importando...",
        [EnumFileUploadStatus.Success]: "Sucesso",
        [EnumFileUploadStatus.Error]: "Erro",
    }), []);

    const handleDelete = React.useCallback((file: DataRow<IFile>) => () => {
        if (!isLoading) {
            data.removeRow(file);
        }
    }, [data, isLoading]);

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>Arquivo</TableHeaderCell>
                    <TableHeaderCell>Status</TableHeaderCell>
                    <TableHeaderCell>Descrição do Erro</TableHeaderCell>
                    <TableHeaderCellAction />
                </TableRow>
            </TableHead>

            <TableBody>
            {
                data.items.map((file, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{file.arquivo.name}</TableCell>
                            <TableCell className={statusColors[file.uploadStatus]}>{statusLabels[file.uploadStatus]}</TableCell>
                            <TableCell>{file.error}</TableCell>
                            <TableCell>
                                {
                                    file.uploadStatus === EnumFileUploadStatus.Awaitting && (
                                        <IconButton onClick={handleDelete(file)} disabled={isLoading}>
                                            <DeleteForeverIcon />
                                        </IconButton>
                                    )
                                }
                            </TableCell>
                        </TableRow>
                    )
                })
            }
            </TableBody>
        </TableNoResult>
    )
}